import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=48ea5630&"
import script from "./Settings.vue?vue&type=script&lang=ts&"
export * from "./Settings.vue?vue&type=script&lang=ts&"
import style0 from "./Settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports